import { useEffect, useState, useLayoutEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ProductDetailsModal from './ProductDetailsModel'
import ProductActivationStepsModal from './ProductActivationStepsModal'
import NicknameSetupModal from './NicknameSetupModal'
import NotificaitonSettings from '../NotificationSettings'
import NotificationSettings from '../MyAccount/Notifications/NotificationSettings'
import Legend from '../Dashboard/Legend'
import Modal from '../common/Modal'
import Dropdown from '../common/Dropdown'
import Breadcrumb from '../common/Breadcrumb'
import SearchWithFilter from '../common/SearchWithFilter'
import FiltersModal, { FilterType } from '../common/FiltersModal'
import LoadingSpinner from '../common/LoadingSpinner'
import DashboardHeader from '../common/DashboardHeader/DashboardHeader'
import SimpleButton from '../common/SimpleButton'
import EmptyPageResults from '../common/EmptyPageResults'
import VideoModal from '../common/VideoModal'
import TooltipedIcon from '../common/TooltipedIcon'
import CycleDetailsModal from '../common/CycleDetailsModal'
import ConfirmationModal from '../common/ConfirmationModal'
import { toast } from '../common/Toast'
import RegisterProductModern from '../RegisterProductModern'
import Documents from '../Documents'
import Videos from '../Videos'
import OnlineAccess from '../OnlineAccess'
import CycleModal from '../InstrumentTracking/CycleModal'
import { useWindowSize } from '../../libs/hooks'
import {
  ApertureIcon,
  UpdateIcon,
  DownloadModernIcon,
  VerifiedIcon,
  VideoPlayIcon,
  CheckDoubleIcon,
  WasherSmallIcon,
  SterilizerSmallIcon,
  InformationIcon,
  ExternalUrlIcon,
} from '../../icons'
import { capitalizeFirstLetter, getFileIcon, getImageByModel, isG4orG4PlusProduct, replaceExtension } from '../../utils/functions'
import { getDocuments } from '../../utils/requests/documentsApi'
import { getVideosList } from '../../utils/requests/videosAPI'
import { getEndUserProductSummary, syncBravoCyclesApi } from '../../utils/requests/productsAPI'
import { getLatestProductCycles, getProductCycleDetails, getProductCyclePrintout, deleteProduct } from '../../utils/requests/productsAPI'
import { getCycleDetails, getMQTTCycles, getTrackingDta } from '../../utils/requests/trackingAPI'
import { putApertureNickname, updateCustomFields } from '../../utils/requests/usersAPI'
import { getOnlineAccessActivationModels } from '../../utils/requests/onlineActivation'
import { combineUserProductsAndApertures } from '../../utils/aperture'
import { publishApertureNicknameUpdate } from '../../utils/requests/mqttPublishAPI'
import { handleSetUserProducts } from '../../actions/userProducts'
import { convertToSimpleDateWithFullTime, formatDate, formatTime, formatVal } from '../../utils/filters/date'
import { keyboardEvents } from '../../utils/keyboardEvents'
import { uniqBy } from '../../utils/filters/filters'
import { downloadFirmware, getUserProductFirmware } from '../../utils/requests/firmwareAPI'
import { trackEvent, gaActions, gaCategories } from '../../utils/ga4'
import { handleDocumentDownload } from '../../utils/documentUtils'
import { useAppContext } from '../../libs/contextLib'
import { handleSetApertures } from '../../actions/aperture'
import { setBackNavigationState } from '../../actions/backNavigationState'
import { COLTENE_BRANCH_UUID } from '../../actions/root'
import {
  checkPermission,
  deviceNotificationsReadPermissions,
  hasCorporateAdminModulesPermission,
  hasInstrumentTrackingPermission,
  userNotificationWritePermission,
  userProductsWritePermission,
} from '../../utils/permissionValidation'
import { useFirmwareSteps } from '../../hooks/useFirmwareSteps'
import './my-products.scss'

const orderingFields = [
  {
    field: 'model',
    order: 'asc',
    translationKey: 'model_asc',
  },
  {
    field: 'model',
    order: 'desc',
    translationKey: 'model_desc',
  },
  {
    field: 'serial_number',
    order: 'asc',
    translationKey: 'serial_number_asc',
  },
  {
    field: 'serial_number',
    order: 'desc',
    translationKey: 'serial_number_desc',
  },
]

const MyProducts = (props) => {
  const { t, i18n } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const isMobile = useWindowSize()[0] <= 768
  const { showFeatureDev, supportsColteneStore } = useAppContext()
  const { dispatch } = props
  const canAccessInstrumentTracking = hasInstrumentTrackingPermission(props.userPermissions)
  const savedProductState = (() => {
    try {
      const saved = sessionStorage.getItem('myProducts_selectedProduct')
      return saved ? JSON.parse(saved) : null
    } catch {
      return null
    }
  })()
  const model = (location.state && location.state?.model) || props.backNavigationState?.model || window.history.state?.model || savedProductState?.model
  const serialNumber =
    (location.state && location.state?.serialNumber) ||
    props.backNavigationState?.serialNumber ||
    window.history.state?.serialNumber ||
    savedProductState?.serialNumber
  const [products, setProducts] = useState([])
  const [serials, setSerials] = useState([])
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [selectedSerial, setSelectedSerial] = useState(null)
  const [combinedProductsAndApertures, setCombinedProductsAndApertures] = useState({})
  const [lastCycles, setLastCycles] = useState([])
  const [documents, setDocuments] = useState([])
  const [videos, setVideos] = useState([])
  const [firmwareVideo, setFirmwareVideo] = useState(null)
  const [instructionSoftwares, setInstructionSoftwares] = useState([])
  const [displayedInstructionSoftware, setDisplayedInstructionSoftware] = useState(null)
  const [uiSoftwares, setUiSoftwares] = useState([])
  const [uiControlSoftwares, setUiControlSoftwares] = useState([])
  const [devicePrefix, setDevicePrefix] = useState(null)
  const [devicePrefixNumber, setDevicePrefixNumber] = useState(null)
  const [currentSoftwareVersion, setCurrentSoftwareVersion] = useState('')
  const [latestSoftwareVersion, setLatestSoftwareVersion] = useState('')
  const [relatedProducts, setRelatedProducts] = useState([])
  const [productSerialNickname, setProductSerialNickname] = useState(null)
  const [hasOnlineAccess, setHasOnlineAccess] = useState(false)
  const [hasPrivacyPolicyChecked, setHasPrivacyPolicyChecked] = useState(false)
  const [hasUpdateAvailable, setHasUpdateAvailable] = useState(false)
  const [productIsAperture, setProductIsAperture] = useState(false)
  const [cycleDetails, setCycleDetails] = useState({})
  const [cycleDetailsDeviceData, setCycleDetailsDeviceData] = useState({})
  const [selectedVideo, setSelectedVideo] = useState(null)
  const [showSpinner, setShowSpinner] = useState(null)
  const [isBravoProduct, setIsBravoProduct] = useState(false)
  const [isJeniProduct, setIsJeniProduct] = useState(false)
  const [isICTrackProduct, setIsICTrackProduct] = useState(false)
  const [showNotifications, setShowNotifications] = useState(false)
  const [showCycleDetails, setShowCycleDetails] = useState(false)
  const [showRegisterProduct, setShowRegisterProduct] = useState(false)
  const [showVideosModal, setShowVideosModal] = useState(false)
  const [showDocumentsModal, setShowDocumentsModal] = useState(false)
  const [showProductActivationStepsModal, setShowProductActivationStepsModal] = useState(false)
  const [showNicknameSetupModal, setShowNicknameSetupModal] = useState(false)
  const [showDeleteNicknameModal, setShowDeleteNicknameModal] = useState(false)
  const [cyclesLoading, setCyclesLoading] = useState(true)
  const [lastCycleDate, setLastCycleDate] = useState(null)
  const [modelId, setModelId] = useState(null)
  const [showLimitedLikedDevice, setShowLimitedLikedDevice] = useState(true)
  const [showBravoOnlineAccess, setShowBravoOnlineAccess] = useState(false)
  const [showJeniOnlineAccess, setShowJeniOnlineAccess] = useState(false)
  const [activationModels, setActivationModels] = useState(null)
  const [showInstrumentTrackingDetails, setShowInstrumentTrackingDetails] = useState(false)
  const [showRemoveProductConfirmationModal, setShowRemoveProductConfirmationModal] = useState(false)
  const [showRemoveAssociationConfirmationModal, setShowRemoveAssociationConfirmationModal] = useState(false)
  const [documentsLanguageFilter, setDocumentsLanguageFilter] = useState(null)
  const [canRegisterProduct, setCanRegisterProduct] = useState(false)
  const [flattenedProducts, setFlattenedProducts] = useState([])
  const [filteredProducts, setFilteredProducts] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [orderBy, setOrderBy] = useState(null)
  const [modelFilter, setModelFilter] = useState([])
  const [availableModels, setAvailableModels] = useState([])
  const [showFiltersModal, setShowFiltersModal] = useState(false)
  const [shouldApplyFilters, setShouldApplyFilters] = useState(true)
  const [showTilesView, setShowTilesView] = useState(!model)
  const [navigationKey] = useState(location.key)
  const [hasInitializedNavigation, setHasInitializedNavigation] = useState(false)
  const isExternalNavigation = !!(location.state?.model && location.state?.serialNumber)
  const cyclesLimit = process.env.REACT_APP_CYCLES_LIMIT || 10
  const documentsLimit = process.env.REACT_APP_DOCUMENTS_LIMIT || 4
  const videosLimit = process.env.REACT_APP_VIDEOS_LIMIT || 3
  const linkedDevicesLimit = 4
  const isG4PlusAPIEnabled = process.env.REACT_APP_G4PLUS_API_TOGGLE === 'on'
  const isG4Device = isG4orG4PlusProduct(selectedSerial)
  const isHydrim112Model = selectedProduct?.model?.toLowerCase().includes('hydrim 112')
  const { renderModelSteps, renderProductSteps } = useFirmwareSteps()

  useEffect(() => {
    trackEvent({
      action: gaActions.featureClick,
      category: gaCategories.productPage,
      label: 'My Products Page: Page View',
    })
  }, [])

  useEffect(() => {
    getOnlineAccessActivationModels()
      .then((models) => {
        const options = models.data.map((name) => ({
          key: name,
          value: name,
        }))
        setActivationModels(options)
      })
      .catch(() => {
        setActivationModels([])
      })
  }, [])

  const handleRegisterProductModal = (isOpen) => {
    trackEvent({
      action: gaActions.featureClick,
      category: gaCategories.productPage,
      label: `My Products Page: Register Product Modal ${isOpen ? 'Opened' : 'Closed'}`,
    })
    setShowRegisterProduct(isOpen)
  }

  const handleDocumentsModal = (isOpen) => {
    trackEvent({
      action: gaActions.featureClick,
      category: gaCategories.productPage,
      label: `My Products Page: Documents Modal ${isOpen ? 'Opened' : 'Closed'}`,
    })
    setShowDocumentsModal(isOpen)
  }

  const handleVideosModal = (isOpen) => {
    trackEvent({
      action: gaActions.featureClick,
      category: gaCategories.productPage,
      label: `My Products Page: Videos Modal ${isOpen ? 'Opened' : 'Closed'}`,
    })
    setShowVideosModal(isOpen)
  }

  useLayoutEffect(() => {
    dispatch(handleSetUserProducts({ cognitoSub: props.authedUser?.cognitoSub }))
    if (canAccessInstrumentTracking && showFeatureDev) {
      dispatch(handleSetApertures(props.authedUser.cognitoSub))
    }
  }, [])

  useLayoutEffect(() => {
    const websiteLanguage = i18n.language.split('-')[0].toUpperCase() || 'EN'
    setDocumentsLanguageFilter(websiteLanguage)
  }, [i18n.language])

  useEffect(() => {
    const handleBeforeUnload = () => {
      window.history.replaceState(
        {
          model: selectedProduct?.model,
          serialNumber: selectedSerial?.serial_number,
        },
        '',
      )
    }
    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [selectedProduct?.model, selectedSerial?.serial_number])

  useEffect(() => {
    sessionStorage.removeItem('myProducts_selectedProduct')
  }, [])

  useEffect(() => {
    const isCorporateAdmin = hasCorporateAdminModulesPermission(props.userPermissions)
    if (isCorporateAdmin) {
      const colteneBranchId = localStorage.getItem(COLTENE_BRANCH_UUID)
      const isBranchAdmin = props.userBranches?.find((branch) => branch.branchUuid === colteneBranchId)?.email === props.authedUser?.email

      if (isBranchAdmin) {
        setCanRegisterProduct(true)
      }

      return
    }

    setCanRegisterProduct(true)
  }, [props.userPermissions, props.userBranches])

  useEffect(() => {
    if (props.userProducts) {
      setShowSpinner(true)

      const groupedProducts = Object.values(props.userProducts)?.reduce((acc, userProduct) => {
        const model = userProduct.model

        let hasUpdateAvailable = false
        if (userProduct.is_g4 || userProduct.is_g4_plus) {
          hasUpdateAvailable = userProduct.association_active ? props.devicesUpdateAvailableStatus[userProduct.serial_number]?.update_available || false : false
        } else {
          hasUpdateAvailable = props.devicesUpdateAvailableStatus[userProduct.serial_number]?.update_available || false
        }

        const modelIndex = acc.findIndex((item) => item.model === model)
        const modelFound = modelIndex !== -1

        if (!modelFound) {
          acc.push({
            model,
            products: [userProduct],
            hasUpdateAvailable,
          })
        } else {
          acc[modelIndex].products.push(userProduct)
          acc[modelIndex].hasUpdateAvailable = acc[modelIndex].hasUpdateAvailable || hasUpdateAvailable
        }

        return acc
      }, [])

      groupedProducts?.sort((a, b) => {
        return a.model?.toLowerCase()?.localeCompare(b.model?.toLowerCase())
      })

      const userProductsCombinedWithApertures = combineUserProductsAndApertures(props.userPermissions, props.userProducts, props.apertures, t)
      setCombinedProductsAndApertures(userProductsCombinedWithApertures)

      const userProductsSerialNumbers = Object.values(props.userProducts)?.map((userProduct) => userProduct.serial_number)

      const groupedAperturesByType = props.apertures?.reduce((acc, aperture) => {
        if (aperture.devices?.length > 0) {
          const typeIndex = acc.findIndex((item) => item.type === aperture.type)
          const typeFound = typeIndex !== -1

          if (!typeFound) {
            acc.push({
              type: aperture.type,
              devices: [...aperture.devices],
            })
          } else {
            acc[typeIndex].devices.push.apply(acc[typeIndex].devices, aperture.devices)
          }
        }

        return acc
      }, [])

      const aperturesAsProducts = groupedAperturesByType.map((aperture) => {
        return {
          model: aperture.type,
          products: aperture.devices.map((device) => {
            return {
              serial_number: device.serial_number,
              model_id: device.model_id,
              unit_nickname: device.nickname,
              isSciCanProduct: userProductsSerialNumbers.includes(device.serial_number),
            }
          }),
          hasUpdateAvailable: false,
          isICTrackProduct: true,
        }
      })

      if (canAccessInstrumentTracking && showFeatureDev) {
        groupedProducts.push(...aperturesAsProducts)
      }

      setProducts(groupedProducts)
      setShowSpinner(false)

      // Build flattened products for tiles view
      const combined = combineUserProductsAndApertures(props.userPermissions, props.userProducts, props.apertures, t)
      const flattened = Object.values(combined).map((product) => ({
        ...product,
        model_display: product.is_ic_track || product.isAperture ? t([`products.${product.model}`, product.model]) : product.model,
        hasUpdateAvailable:
          product.is_g4 || product.is_g4_plus
            ? product.association_active
              ? props.devicesUpdateAvailableStatus[product.serial_number]?.update_available || false
              : false
            : props.devicesUpdateAvailableStatus[product.serial_number]?.update_available || false,
        hasOnlineAccess: product.association_active || false,
        hasPrivacyPolicyChecked: product.privace_policy_checked === 1,
        isICTrackProduct: product.is_ic_track || product.isAperture || false,
      }))

      flattened.sort((a, b) => {
        const modelCompare = a.model.toLowerCase().localeCompare(b.model.toLowerCase())
        if (modelCompare !== 0) return modelCompare
        return a.serial_number.localeCompare(b.serial_number)
      })

      const groupedByType = {}
      flattened.forEach((product) => {
        const productType = product.product_type || 'Other'
        if (!groupedByType[productType]) {
          groupedByType[productType] = []
        }
        groupedByType[productType].push(product)
      })

      setFlattenedProducts(flattened)
      setFilteredProducts(groupedByType)

      const uniqueModels = [...new Set(flattened.map((p) => p.model))].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
      setAvailableModels(uniqueModels)

      if (model || selectedProduct) {
        const preselectedProduct = groupedProducts.find((product) => product.model === model || product.model === selectedProduct?.model)

        if (preselectedProduct) {
          setSelectedProduct(preselectedProduct)
          setShowTilesView(false)

          if (!preselectedProduct.isICTrackProduct) {
            setSerials(preselectedProduct?.products)

            if (serialNumber || selectedSerial) {
              const preselectedSerial = preselectedProduct.products?.find(
                (product) => product.serial_number === serialNumber || product.serial_number === selectedSerial?.serial_number,
              )
              setSelectedSerial(preselectedSerial)
            }
          }

          setIsICTrackProduct(preselectedProduct.isICTrackProduct)

          window.history.replaceState({}, '')
        }
      }
    }
  }, [props.userProducts, model, serialNumber, props.apertures])

  useEffect(() => {
    async function fetchData() {
      if (selectedProduct?.model) {
        setShowSpinner(true)

        setIsBravoProduct(selectedProduct.model?.toLowerCase().includes('bravo'))
        setIsJeniProduct(selectedProduct.model?.toLowerCase().includes('canalpro jeni evo'))

        const documentsQueryParams = {
          page: 1,
          model: selectedProduct.model,
          exclude: 'category:technical service bulletin',
          lang: documentsLanguageFilter,
        }

        let instrumentTrackingQueryParams = {}

        if (selectedProduct.isICTrackProduct) {
          const todayTime = new Date()
          const today = new Date(new Date(todayTime).setHours(23, 59, 59))
          let startDate = new Date(today)
          startDate = new Date(startDate.setDate(today.getDate() - 6))

          instrumentTrackingQueryParams = {
            cycleStart: `${startDate.getFullYear()}${formatVal(startDate.getMonth() + 1)}${formatVal(startDate.getDate())}`,
            cycleEnd: `${today.getFullYear()}${formatVal(today.getMonth() + 1)}${formatVal(today.getDate())}`,
          }
        }

        const [documentsResult, instrumentTrackingCyclesResult] = await Promise.allSettled([
          getDocuments(documentsQueryParams, documentsLimit),
          ...(selectedProduct.isICTrackProduct ? [getTrackingDta(instrumentTrackingQueryParams)] : []),
        ])

        if (documentsResult?.status === 'fulfilled' && documentsResult?.value?.data) {
          setDocuments(documentsResult.value.data)
        }

        if (instrumentTrackingCyclesResult?.status === 'fulfilled' && instrumentTrackingCyclesResult?.value?.length > 0) {
          mapInstrumentTrackingCycles(instrumentTrackingCyclesResult.value)
        }

        setShowSpinner(false)
      }
    }
    fetchData()
  }, [selectedProduct?.model, documentsLanguageFilter])

  useEffect(() => {
    if (selectedSerial?.serial_number) {
      setShowSpinner(true)

      let currentHasOnlineAccess = selectedSerial.association_active
      let currentProductSerialNickname = selectedSerial.unit_nickname
      let currentProductIsAperture = combinedProductsAndApertures[selectedSerial.serial_number]?.isAperture
      let deviceHasUpdateAvailable = selectedSerial.association_active && props.devicesUpdateAvailableStatus[selectedSerial.serial_number]?.update_available

      getVideosList({ model: selectedProduct.model }).then((result) => {
        const allVideos = result.data || []

        const onlineAccessVideos = allVideos.filter((video) => video.category === 'Online Access')
        const otherVideos = allVideos.filter((video) => video.category !== 'Online Access')

        const videosToShow = currentHasOnlineAccess || !onlineAccessVideos[0] ? otherVideos : [onlineAccessVideos[0], ...otherVideos]
        setVideos(videosToShow.slice(0, videosLimit))
      })

      getEndUserProductSummary(props.authedUser?.cognitoSub, selectedSerial.serial_number, {
        model_id: selectedSerial.model_id ?? '',
      })
        .then((response) => {
          const data = response.data

          currentHasOnlineAccess = data.association_active === 1
          currentProductSerialNickname = data.product_nickname
          currentProductIsAperture = data.isAperture
          setHasPrivacyPolicyChecked(data.privace_policy_checked === 1)
          data.model_id && setModelId(data.model_id)

          if (showFeatureDev && selectedSerial.is_g4_plus && isG4PlusAPIEnabled) {
            getMQTTCycles(selectedSerial.serial_number)
              .then((cycles) => {
                let eventData = []
                if (cycles.length > 0) {
                  eventData = cycles
                    .sort((a, b) => new Date(b.cycleStartDateTime) - new Date(a.cycleStartDateTime) || b.cycleNumber - a.cycleNumber)
                    .slice(0, cyclesLimit)
                    .map((cycle) => {
                      return {
                        title: cycle.cycleFault ? `C# ${cycle.cycleNumber} CF-${cycle.cycleFault}` : `C# ${cycle.cycleNumber}`,
                        className: cycle.cycleEvent ? cycle.cycleEvent?.toLowerCase().replace(/_/g, '-') : 'cycle-pending',
                        start: convertToSimpleDateWithFullTime(cycle.cycleStartDateTime),
                        end: convertToSimpleDateWithFullTime(cycle.cycleEndDateTime),
                        cycleDate: cycle.cycleStartDateTime,
                        serial_number: cycle.deviceSerialNumber,
                        cycle_number: cycle.cycleNumber,
                        cycle_fault: cycle.cycleFault,
                        recordsUuid: cycle.recordsUuid,
                      }
                    })
                }

                setLastCycleDate(eventData[0]?.start)
                setLastCycles(eventData)

                setCyclesLoading(false)
                setShowSpinner(false)
              })
              .catch((e) => {
                console.log('something went wrong', e.message)
                setCyclesLoading(false)
                setShowSpinner(false)
              })
          } else {
            getLatestProductCycles(props.authedUser?.cognitoSub, selectedSerial.serial_number, {
              limit: cyclesLimit,
            })
              .then((cycles) => {
                let eventData = []
                if (cycles.data) {
                  eventData = cycles.data
                    .sort((a, b) => new Date(b.start) - new Date(a.start) || b.cycle_number - a.cycle_number)
                    .map((cycle) => {
                      return {
                        title: cycle.cycle_fault ? `C# ${cycle.cycle_number} CF-${cycle.cycle_fault}` : `C# ${cycle.cycle_number}`,
                        className: cycle.cycle_event ? cycle.cycle_event.toLowerCase().replace(/_/g, '-') : 'cycle-pending',
                        cycleDate: cycle.start,
                        ...cycle,
                      }
                    })
                }

                setLastCycleDate(eventData[0]?.start)
                setLastCycles(eventData)

                setCyclesLoading(false)
                setShowSpinner(false)
              })
              .catch((e) => {
                console.log('something went wrong', e.message)
                setCyclesLoading(false)
                setShowSpinner(false)
              })
          }

          if (currentHasOnlineAccess && deviceHasUpdateAvailable) {
            loadFirmwareDetails()
          }
        })
        .catch(() => {
          setShowSpinner(false)
          setCyclesLoading(false)
        })
        .finally(() => {
          setHasOnlineAccess(currentHasOnlineAccess)
          setProductSerialNickname(currentProductSerialNickname)
          setProductIsAperture(currentProductIsAperture)

          if (!isG4Device) {
            loadFirmwareDetails()
          }
        })
    }
  }, [selectedSerial?.serial_number])

  useEffect(() => {
    if (instructionSoftwares.length && documentsLanguageFilter) {
      let instructionFileToDisplay = instructionSoftwares.filter((file) => file.languageCode === documentsLanguageFilter)

      if (!instructionFileToDisplay) {
        instructionFileToDisplay = instructionSoftwares.filter((file) => file.languageCode === 'EN') || instructionSoftwares
      }

      setDisplayedInstructionSoftware(instructionFileToDisplay)
    }
  }, [instructionSoftwares, documentsLanguageFilter])

  const loadFirmwareDetails = async () => {
    const result = await getUserProductFirmware(props.authedUser?.cognitoSub, selectedSerial.serial_number, {
      model: selectedSerial.model,
      model_id: selectedSerial.model_id,
    })

    if (!result?.data?.versions?.length) {
      return
    }

    let files = []

    result.data.versions.forEach((version) => {
      files.push(
        version.files.map((file) => {
          return {
            ...file,
            version_id: version.id,
          }
        }),
      )
    })

    const versions = uniqBy(result.data.versions, 'id')

    const mappedVersionsWithFiles = versions.map((version) => {
      version.files = []

      files = [].concat(...files)
      files.forEach((file) => {
        if (file.version_id === version.id) {
          version.files.push(file)
        }
      })
      return version
    })
    const instructionSoftwares = mappedVersionsWithFiles[0]?.files?.filter((file) => file.software_type === 'Instruction') || []
    const uiSoftwares = mappedVersionsWithFiles[0]?.files?.filter((file) => file.software_type === 'UI') || []
    const uiControlSoftwares = mappedVersionsWithFiles[0]?.files?.filter((file) => file.software_type === 'UI+Control') || []

    if (uiSoftwares.length || uiControlSoftwares.length) {
      setDevicePrefix(result.data.prefix)
      setDevicePrefixNumber(result.data.prefix_number)
      setCurrentSoftwareVersion(result.data.current_version || '')

      const latestVersionFiles = mappedVersionsWithFiles[0]?.files || []
      const latestVersionLabel =
        latestVersionFiles.length === 1
          ? latestVersionFiles[0].label
          : latestVersionFiles.find((file) => file.software_type === 'UI')?.label || result.data.latest_version
      setLatestSoftwareVersion(latestVersionLabel || '')

      setHasUpdateAvailable(props.devicesUpdateAvailableStatus[selectedSerial.serial_number]?.update_available || false)

      setInstructionSoftwares(instructionSoftwares)
      setUiSoftwares(uiSoftwares)
      setUiControlSoftwares(uiControlSoftwares)
    }

    getVideosList({
      page: 1,
      model: selectedProduct.model,
      limit: 1,
      category: 'Firmware Download',
    }).then((result) => {
      setFirmwareVideo(result.data[0] || null)
    })
  }

  const selectSerial = (serialNumber) => {
    trackEvent({
      action: gaActions.featureClick,
      category: gaCategories.productPage,
      label: `My Products Page: Serial Selected - ${serialNumber}`,
    })

    setProductSerialNickname(null)
    setHasPrivacyPolicyChecked(false)
    setHasOnlineAccess(false)
    setLastCycles([])
    setCyclesLoading(true)
    setDevicePrefix(null)
    setDevicePrefixNumber(null)
    setInstructionSoftwares([])
    setDisplayedInstructionSoftware(null)
    setUiSoftwares([])
    setUiControlSoftwares([])
    setHasUpdateAvailable(false)

    const serial = serials.find((serial) => serial.serial_number === serialNumber)
    setSelectedSerial(serial)
  }

  const renderProductOnlineAccess = (associationActive) => {
    return <div className="online-access">{associationActive ? <VerifiedIcon /> : <VerifiedIcon className="no-access" />}</div>
  }

  const navigateToProduct = (serialNumber) => {
    const scicanProduct = products.find((product) => !product.isICTrackProduct && product.products?.find((product) => product.serial_number === serialNumber))

    if (scicanProduct) {
      setIsICTrackProduct(false)
      setSelectedProduct(scicanProduct)

      setSerials(scicanProduct.products)

      const sicanSerial = scicanProduct.products.find((product) => product.serial_number === serialNumber)
      setSelectedSerial(sicanSerial)
      setLastCycles([])
    }
  }

  const navigateToProductPage = (serialNumber) => {
    trackEvent({
      action: gaActions.featureClick,
      category: gaCategories.productPage,
      label: 'Product Page: Calendar Click',
    })

    const navSerialNumber = selectedSerial?.serial_number || serialNumber
    props.actions.setBackNavigationState({
      backNavPage: location.pathname,
      serialNumber: navSerialNumber,
      model: selectedProduct.model,
    })
    sessionStorage.setItem('myProducts_selectedProduct', JSON.stringify({ model: selectedProduct.model, serialNumber: navSerialNumber }))

    history.push({
      pathname: `/products/${navSerialNumber}`,
      state: {
        lastCycleDate: lastCycleDate,
        is_g4_plus: selectedSerial.is_g4_plus,
        withBackNavigation: true,
      },
    })
  }

  const navigateToInstrumentTracking = () => {
    trackEvent({
      action: gaActions.featureClick,
      category: gaCategories.productPage,
      label: 'My Products Page: Navigate to Instrument Tracking',
    })

    props.actions.setBackNavigationState({
      backNavPage: location.pathname,
      model: selectedProduct.model,
    })
    sessionStorage.setItem('myProducts_selectedProduct', JSON.stringify({ model: selectedProduct.model, serialNumber: selectedSerial?.serial_number }))

    history.push({
      pathname: `/instrument-tracking`,
      state: {
        withBackNavigation: true,
      },
    })
  }

  const navigateToInstrumentTrackingReports = () => {
    trackEvent({
      action: gaActions.featureClick,
      category: gaCategories.productPage,
      label: 'My Products Page: Navigate to Instrument Tracking Reports',
    })

    props.actions.setBackNavigationState({
      backNavPage: location.pathname,
      model: selectedProduct.model,
    })
    sessionStorage.setItem('myProducts_selectedProduct', JSON.stringify({ model: selectedProduct.model, serialNumber: selectedSerial?.serial_number }))

    history.push({
      pathname: `/reports`,
      state: {
        withBackNavigation: true,
      },
    })
  }

  const navigateToColteneStore = () => {
    props.actions.setBackNavigationState({
      backNavPage: location.pathname,
      model: selectedProduct.model,
    })
    sessionStorage.setItem('myProducts_selectedProduct', JSON.stringify({ model: selectedProduct.model, serialNumber: selectedSerial?.serial_number }))

    history.push({
      pathname: `/coltene-store`,
      state: {
        withBackNavigation: true,
      },
    })
  }

  const cycleNavigateToTroubleshooting = () => {
    props.actions.setBackNavigationState({
      backNavPage: location.pathname,
      serialNumber: selectedSerial?.serial_number,
      model: selectedProduct.model,
    })
    sessionStorage.setItem('myProducts_selectedProduct', JSON.stringify({ model: selectedProduct.model, serialNumber: selectedSerial?.serial_number }))
  }

  const mapInstrumentTrackingCycles = (instrumentTrackingCyclesData) => {
    const getCycleStatus = (status) => {
      if (status?.toLowerCase().includes('complete')) {
        return 'cycle-tracking-completed'
      } else if (status?.toLowerCase().includes('fault') || status?.toLowerCase() === 'cycle_aborted' || status?.toLowerCase() === 'door_open') {
        return 'cycle-tracking-error'
      } else if (status?.toLowerCase() === 'cycle_power_interrupt') {
        return 'cycle-tracking-interrupted'
      } else {
        return 'cycle-tracking-in-progress'
      }
    }

    const specificInstrumentTrackingCycles = instrumentTrackingCyclesData.filter((cycle) => cycle.deviceType === selectedProduct.model)

    let eventData = []
    if (specificInstrumentTrackingCycles.length > 0) {
      eventData = specificInstrumentTrackingCycles
        .sort((a, b) => new Date(b.cycleStartDateTime) - new Date(a.cycleStartDateTime) || b.cycleNumber - a.cycleNumber)
        .slice(0, cyclesLimit)
        .map((cycle) => {
          return {
            title: cycle.cycleNumber ? `C# ${cycle.cycleNumber}` : '',
            className: getCycleStatus(cycle.status),
            type: cycle.deviceType,
            start: cycle.cycleStartDateTime,
            end: cycle.cycleEndDateTime,
            cycleDate: cycle.cycleStartDateTime,
            serial_number: cycle.deviceSerialNumber,
            cycle_number: cycle.cycleNumber,
            cycle_fault: cycle.cycleFault,
            recordsUuid: cycle.recordsUuid,
            printoutFileName: cycle.printout_file_name,
            nickName: cycle.deviceNickname,
            ...cycle,
          }
        })
    }

    setLastCycles(eventData)
  }

  const handleOpenCycleDetails = (cycle) => {
    if (isICTrackProduct) {
      setCycleDetailsDeviceData(cycle)
    } else {
      setCycleDetailsDeviceData({
        model: selectedProduct.model,
        cycleNumber: cycle.cycle_number,
        cycleStartTime: cycle.cycleDate,
        deviceSerialNumber: cycle.serial_number,
        cycleFault: cycle.cycle_fault,
      })
    }

    const userProduct = props.userProducts[cycle.serial_number]

    if (isICTrackProduct && (!cycle.serial_number || !userProduct)) {
      setShowInstrumentTrackingDetails(true)
      return
    }

    let fetchCycleDetailsPromise

    if (showFeatureDev && userProduct.is_g4_plus && isG4PlusAPIEnabled) {
      fetchCycleDetailsPromise = getCycleDetails(cycle.recordsUuid, cycle.serial_number)
    } else if (cycle.printoutFileName) {
      fetchCycleDetailsPromise = getProductCyclePrintout(cycle.printoutFileName)
    } else if (cycle.cid) {
      fetchCycleDetailsPromise = getProductCycleDetails(cycle.serial_number, cycle.cid, { model_id: selectedSerial?.model_id || modelId })
    } else {
      if (isICTrackProduct) {
        setShowInstrumentTrackingDetails(true)
      }

      return
    }

    setShowSpinner(true)

    fetchCycleDetailsPromise
      .then((res) => {
        setShowSpinner(false)

        setCycleDetails(res.data || res)

        if (isICTrackProduct) {
          setShowInstrumentTrackingDetails(true)
          return
        }

        setShowCycleDetails(true)
      })
      .catch((error) => {
        setShowSpinner(false)

        toast.error(t([`error.${error?.response?.data?.code}`, 'error.something_wrong']))

        if (isICTrackProduct) {
          setShowInstrumentTrackingDetails(true)
          return
        }

        setShowCycleDetails(true)
      })
  }

  const handleDeleteProduct = () => {
    setShowSpinner(true)

    deleteProduct(props.authedUser?.cognitoSub, selectedSerial.serial_number)
      .then(() => {
        history.push({
          pathname: `/`,
        })

        toast.success(t('device_context.unit.remove_success'))
      })
      .catch((e) => {
        toast.error(e.response?.data?.code === 'deviceHasCycles' ? t('error.device_has_cycles_contact_support') : t('error.failure_msg'))
      })
      .finally(() => {
        setShowSpinner(false)
      })
  }

  const downloadFirmwareFile = (file) => {
    const body = {
      filename: file.filename || file.label,
      reference_id: file.reference_id,
      prefix: devicePrefix,
      prefix_number: devicePrefixNumber,
      email: props.authedUser.email,
      country: props.authedUser.country,
      type: file?.software_type === 'Instruction' ? 'document' : 'firmware',
    }

    downloadFirmware(file.id, file.filename, file.filepath, body)
  }

  const openVideoModal = (item) => {
    trackEvent({
      action: gaActions.featureClick,
      category: gaCategories.productPage,
      label: `My Products Page: Video Selected - ${item.title}`,
    })

    setSelectedVideo(item)
  }

  const closeVideoModal = () => {
    setSelectedVideo(null)
  }

  const handleChangeNickname = (newProductSerialNickname) => {
    setShowSpinner(true)

    const date = formatDate(new Date())
    const time = formatTime(new Date())

    const params = {
      nickname: newProductSerialNickname,
      nickname_last_updated: `${date} ${time}`,
    }

    updateCustomFields(props.authedUser?.cognitoSub, selectedSerial.serial_number, params)
      .then(() => {
        setProductSerialNickname(newProductSerialNickname)

        dispatch(handleSetUserProducts({ cognitoSub: props.authedUser.cognitoSub }))
        if (canAccessInstrumentTracking && showFeatureDev) {
          dispatch(handleSetApertures(props.authedUser.cognitoSub))
        }

        toast.success(t('device_context.updated'))
        setShowSpinner(false)
      })
      .catch(() => {
        toast.error(t('error.failure_msg'))
        setShowSpinner(false)
      })

    if (canAccessInstrumentTracking && productIsAperture && showFeatureDev) {
      putApertureNickname(
        props.authedUser?.cognitoSub,
        combinedProductsAndApertures[selectedSerial.serial_number].aperture_id,
        combinedProductsAndApertures[selectedSerial.serial_number].device_uuid,
        {
          device_nickname: newProductSerialNickname,
        },
      ).then(() => {
        const units = Object.values(combinedProductsAndApertures).map((value) => {
          const unit = {
            serial_number: value?.serial_number,
            device_nickname: value?.serial_number === selectedSerial.serial_number ? newProductSerialNickname : value?.unit_nickname,
            device_model: value?.model,
          }

          if (value?.isAperture) {
            unit.device_uuid = value?.device_uuid
            unit.manufacturer = value?.manufacturer
            unit.aperture_serial_number = value?.aperture_serial_number
          } else {
            unit.online_access = value?.association_active ? 1 : 0
          }

          return unit
        })

        const payload = {
          accounts: [
            {
              account_state: 'associated',
              account_state_time_modified_utc_seconds: new Date(`${date} ${time}`).getTime(),
              account_email: props.authedUser?.email,
              account_company_name: props.authedUser?.company,
              account_contact_name: props.authedUser?.firstname + ' ' + props.authedUser?.lastname,
              account_phone_number: props.authedUser?.phone,
              account_address: props.authedUser?.postalcode,
              account_city: props.authedUser?.city,
              account_subregion: props.authedUser?.stateprovince,
              account_country: props.authedUser?.country,
              account_zip_code: props.authedUser?.postalcode,
              units: units,
            },
          ],
        }

        publishApertureNicknameUpdate(combinedProductsAndApertures[selectedSerial.serial_number].aperture_serial_number, payload)
      })
    }
  }

  const buildUserFriendlyDate = (date) => {
    if (date) {
      return new Date(date).toLocaleString('en-US', { day: '2-digit', month: 'short', year: 'numeric' })
    }

    return ''
  }
  const mapSerialToModel = (serialNumber) => {
    const matchedProduct = products.find(({ products: subProducts }) => {
      return subProducts.find((p) => p.serial_number === serialNumber)
    })

    return matchedProduct?.model || 'aperture'
  }

  const onSuccessfulOnlineActivation = () => {
    dispatch(handleSetUserProducts({ cognitoSub: props.authedUser?.cognitoSub }))
  }

  const renderFirmwareSection = (softwares, titleKey) => {
    if (!softwares?.length) {
      return null
    }

    return (
      <>
        <div className="internal-section-title">{t(`firmware_context.${titleKey}`)}</div>
        <div className="firmware-executables-wrapper">
          {softwares.map((file, index) => (
            <div className="firmware-executable" key={index}>
              <button className="download-document" onClick={() => downloadFirmwareFile(file)} disabled={showSpinner}>
                <DownloadModernIcon className="download-icon" />
              </button>
              {getFileIcon(file.filename)}
              <div className="file-name">{replaceExtension(file.label || file.filename)}</div>
            </div>
          ))}
        </div>
      </>
    )
  }

  // Tile view navigation effects
  useEffect(() => {
    if (showTilesView && location.state?.scrollToModel && flattenedProducts.length > 0) {
      const product = flattenedProducts.find((p) => p.model === location.state.scrollToModel)
      if (product) {
        const productType = (product.product_type || 'Other').replace(/\s+/g, '-').toLowerCase()
        const element = document.getElementById(`product-type-${productType}`)
        if (element) {
          setTimeout(() => element.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100)
        }
      }
    }
  }, [showTilesView, flattenedProducts, location.state?.scrollToModel])

  useEffect(() => {
    if (showVideosModal || showDocumentsModal) return
    if (location.key !== navigationKey && !location.state?.model && !location.state?.serialNumber) {
      setShowTilesView(true)
      setSelectedProduct(null)
      setSelectedSerial(null)
      setHasInitializedNavigation(false)
    }
  }, [location.key])

  useEffect(() => {
    if (!model || !serialNumber || flattenedProducts.length === 0) return

    const productToSelect = flattenedProducts.find((p) => p.model === model && p.serial_number === serialNumber)

    if (productToSelect && !selectedProduct) {
      setSelectedProduct(productToSelect)
      setSelectedSerial(productToSelect)
      setShowTilesView(false)

      if (!hasInitializedNavigation) {
        setHasInitializedNavigation(true)
      }
    }
  }, [model, serialNumber, flattenedProducts, selectedProduct, hasInitializedNavigation, isExternalNavigation, props.backNavigationState])

  useEffect(() => {
    if (shouldApplyFilters) {
      applyFiltersAndSorting(searchQuery, orderBy, modelFilter)
    }
    setShouldApplyFilters(true)
  }, [modelFilter])

  useEffect(() => {
    if (!showTilesView) {
      return
    }
  }, [showTilesView])

  const handleSearch = (query) => {
    setSearchQuery(query)
    applyFiltersAndSorting(query, orderBy)
  }

  const selectOrderByOptions = (orderByTranslationKey) => {
    const sortOption = orderingFields.find((field) => field.translationKey === orderByTranslationKey)
    const newOrderBy = orderingFields.find((o) => o.field === sortOption.field && o.order === sortOption.order)
    setOrderBy(newOrderBy)
    applyFiltersAndSorting(searchQuery, newOrderBy)
  }

  const handleResetFilters = () => {
    setModelFilter([])
  }

  const applyFiltersAndSorting = (query, sorting, modelFilters = modelFilter) => {
    let filtered = flattenedProducts

    if (modelFilters.length > 0) {
      filtered = filtered.filter((p) => modelFilters.includes(p.model))
    }

    if (query) {
      const lowerQuery = query.toLowerCase()
      filtered = filtered.filter(
        (p) =>
          p.model.toLowerCase().includes(lowerQuery) ||
          p.serial_number.toLowerCase().includes(lowerQuery) ||
          (p.unit_nickname && p.unit_nickname.toLowerCase().includes(lowerQuery)),
      )
    }

    if (sorting?.field && sorting?.order) {
      filtered = [...filtered].sort((a, b) => {
        const aValue = a[sorting.field]?.toLowerCase() || ''
        const bValue = b[sorting.field]?.toLowerCase() || ''
        if (sorting.order === 'asc') {
          return aValue.localeCompare(bValue)
        } else {
          return bValue.localeCompare(aValue)
        }
      })
    }

    const groupedByType = {}
    filtered.forEach((product) => {
      const productType = product.product_type || 'Other'
      if (!groupedByType[productType]) {
        groupedByType[productType] = []
      }
      groupedByType[productType].push(product)
    })

    setFilteredProducts(groupedByType)
  }

  const handleViewProduct = (product) => {
    setLastCycles([])
    setCyclesLoading(true)
    setDocuments([])
    setVideos([])
    setFirmwareVideo(null)
    setInstructionSoftwares([])
    setDisplayedInstructionSoftware(null)
    setUiSoftwares([])
    setUiControlSoftwares([])
    setHasUpdateAvailable(false)
    setHasOnlineAccess(false)
    setHasPrivacyPolicyChecked(false)
    setProductSerialNickname(null)
    setProductIsAperture(false)
    setDevicePrefix(null)
    setDevicePrefixNumber(null)
    setCurrentSoftwareVersion('')
    setLatestSoftwareVersion('')

    setShowTilesView(false)
    setSelectedProduct(product)
    setSelectedSerial(product)
    setHasInitializedNavigation(true)

    // Also set up serials and isICTrackProduct for the detail view
    const groupedProduct = products.find((p) => p.model === product.model)
    if (groupedProduct) {
      setSerials(groupedProduct.products)
      setIsICTrackProduct(groupedProduct.isICTrackProduct || false)
    }
  }

  const handleBackToTiles = () => {
    props.actions.setBackNavigationState({})
    sessionStorage.removeItem('myProducts_selectedProduct')
    window.history.replaceState({}, '')
    if (isExternalNavigation) {
      setSelectedProduct(null)
      setSelectedSerial(null)
      history.replace('/')
    } else {
      setShowTilesView(true)
      setSelectedProduct(null)
      setSelectedSerial(null)
      setHasInitializedNavigation(false)
    }
  }

  const syncBravoCycles = async () => {
    const queryParams = { sn: selectedSerial?.serial_number }
    setShowSpinner(true)

    try {
      await syncBravoCyclesApi(queryParams)
      toast.success(t('device_context.sync_initiated'))
    } catch (error) {
      toast.error(t([`error.${error?.response?.data?.code}`, 'error.something_wrong']))
    } finally {
      setShowSpinner(false)
    }
  }

  return (
    <div className="my-products-wrapper d-flex flex-column">
      <Breadcrumb path={window.location.pathname} withBackNavigation={!showTilesView} onBackClick={handleBackToTiles} />
      <DashboardHeader headerText={t('nav.my_products')}>
        {canRegisterProduct && (
          <SimpleButton className="submit-button" onClick={() => handleRegisterProductModal(true)}>
            {t('device_context.register_product')}
          </SimpleButton>
        )}
      </DashboardHeader>
      <div className="separator" />
      <div className="legend-back-container">
        <Legend canAccessInstrumentTracking={canAccessInstrumentTracking} isDentist />
      </div>
      <div className="separator" />

      {showTilesView ? (
        <>
          <div className="my-products-header">
            <SearchWithFilter
              placeholder={t('search')}
              onSearch={(query) => handleSearch(query)}
              showFiltersModal={() => setShowFiltersModal(true)}
              onResetFilters={() => handleResetFilters()}
              showCounterBadge={modelFilter.length > 0}
              counterBadge={modelFilter.length}
            />
            <div className="dropdown-area">
              <div className="sorting-label">{t('sort_by')}</div>
              <Dropdown
                className="dropdown-input"
                placeholder={t('select_ordering')}
                options={orderingFields.map((field) => ({ key: field.translationKey, value: t(`sortable_context.${field.translationKey}`) }))}
                initialSelectedKey={orderBy?.translationKey}
                onChange={(orderBy) => selectOrderByOptions(orderBy.key)}
              />
            </div>
          </div>
          <div className="branch-container">
            {Object.entries(filteredProducts).map(([productType, products], groupIndex) => (
              <div key={groupIndex} id={`product-type-${productType.replace(/\s+/g, '-').toLowerCase()}`} className="product-type-group">
                <div className="section-title">{t('products.your_product_type', { productType })}</div>
                <div className="products-grid">
                  {products.map((item, index) => (
                    <div
                      key={index}
                      className="wrapper-item"
                      onClick={() => handleViewProduct(item)}
                      tabIndex={0}
                      role="button"
                      onKeyDown={(e) => e.key === keyboardEvents.ENTER && handleViewProduct(item)}
                    >
                      <div className="image-wrapper">
                        <img src={getImageByModel(item.model)} alt={item.model} />
                      </div>
                      <div className="product-info-wrapper">
                        <div className="product-model">{item.model_display}</div>
                        {item.unit_nickname ? (
                          <div className="product-nickname">{`${item.unit_nickname}`}</div>
                        ) : (
                          <div className="product-serial">{`${t('sn')}: ${item.serial_number}`}</div>
                        )}
                        <div className="product-status-icons">
                          <UpdateIcon className={!item.hasUpdateAvailable ? 'unavailable' : ''} />
                          <VerifiedIcon className={`verified-icon${!item.hasOnlineAccess ? ' unavailable' : ''}`} />
                          <CheckDoubleIcon className={!item.hasPrivacyPolicyChecked ? 'unavailable' : ''} />
                        </div>
                        <div className="product-action">
                          <SimpleButton className="action-button">{t('dashboard.view_product')}</SimpleButton>
                        </div>
                      </div>
                      {item.hasUpdateAvailable && <div className="has-update" />}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          {Object.keys(filteredProducts).length === 0 && !props.userProductsAreLoading && <EmptyPageResults title={t('register.no_product_registered')} />}
        </>
      ) : (
        <div className="product-details-full-wrapper">
          {!selectedProduct && showSpinner !== false ? (
            <LoadingSpinner />
          ) : (
            <div className="product-details-content">
              {selectedProduct && !isICTrackProduct ? (
                <div className="product-info-section">
                  {selectedSerial && (
                    <>
                      <div className="product-status-wrapper">
                        <div className="image-wrapper d-flex flex-align-center">
                          <img src={getImageByModel(selectedProduct.model)} className="img" alt={selectedProduct.model} />
                        </div>
                        <div className="product-serial-wrapper">
                          <div className="product-serial">{`${t('sn')}: ${selectedSerial.serial_number}`}</div>
                          {hasOnlineAccess && (
                            <div className="product-serial-subtitle">
                              {productSerialNickname ? (
                                <div className="nickname-wrapper">
                                  <span className="product-nickname">{productSerialNickname}</span>
                                  <div className="nickname-actions-wrapper">
                                    <span
                                      className={'delete-nickname' + (!hasOnlineAccess || productIsAperture ? ' disabled' : '')}
                                      onClick={() => hasOnlineAccess && !productIsAperture && setShowDeleteNicknameModal(true)}
                                      tabIndex={0}
                                      role="button"
                                      onKeyDown={(e) =>
                                        e.key === keyboardEvents.ENTER && hasOnlineAccess && !productIsAperture && setShowDeleteNicknameModal(true)
                                      }
                                    >
                                      {t('delete')}
                                    </span>
                                    <span
                                      className={'edit-nickname' + (!hasOnlineAccess ? ' disabled' : '')}
                                      onClick={() => hasOnlineAccess && setShowNicknameSetupModal(true)}
                                      tabIndex={0}
                                      role="button"
                                      onKeyDown={(e) => e.key === keyboardEvents.ENTER && hasOnlineAccess && setShowNicknameSetupModal(true)}
                                    >
                                      {t('edit')}
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                <span
                                  className={'nickname-add-wrapper' + (!hasOnlineAccess ? ' disabled' : '')}
                                  onClick={() => hasOnlineAccess && setShowNicknameSetupModal(true)}
                                  tabIndex={0}
                                  role="button"
                                  onKeyDown={(e) => e.key === keyboardEvents.ENTER && hasOnlineAccess && setShowNicknameSetupModal(true)}
                                >
                                  {t('products.add_nickname')}
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                        <div className="product-status">
                          <div className="product-status-legend">
                            {canAccessInstrumentTracking && showFeatureDev && (
                              <TooltipedIcon
                                icon={<ApertureIcon className={!productIsAperture ? 'unavailable' : ''} />}
                                tooltipText={productIsAperture ? t('products.aperture_associated') : t('products.aperture_not_associated')}
                              />
                            )}
                            <TooltipedIcon
                              icon={<UpdateIcon className={!hasUpdateAvailable ? 'unavailable' : ''} />}
                              tooltipText={hasUpdateAvailable ? capitalizeFirstLetter(t('device_context.update_available')) : t('products.update_not_avilable')}
                            />
                            <TooltipedIcon
                              icon={<VerifiedIcon className={!hasOnlineAccess ? 'unavailable' : ''} />}
                              tooltipText={
                                hasOnlineAccess
                                  ? capitalizeFirstLetter(t('device_context.online_access_active'))
                                  : capitalizeFirstLetter(t('device_context.online_access_inactive'))
                              }
                            />
                            <TooltipedIcon
                              icon={<CheckDoubleIcon className={!hasPrivacyPolicyChecked ? 'unavailable' : ''} />}
                              tooltipText={
                                hasPrivacyPolicyChecked
                                  ? capitalizeFirstLetter(t('device_context.privacy_policy_checked'))
                                  : t('products.privacy_policy_not_accepted')
                              }
                            />
                          </div>
                          <div className="product-status-actions">
                            {selectedSerial.association_active &&
                              !isJeniProduct &&
                              ((checkPermission(props.userPermissions, userNotificationWritePermission) && isBravoProduct) ||
                                checkPermission(props.userPermissions, deviceNotificationsReadPermissions)) && (
                                <SimpleButton className="action-button" disabled={!hasOnlineAccess} onClick={() => setShowNotifications(true)}>
                                  {t('events.device-notifications')}
                                </SimpleButton>
                              )}
                            {selectedSerial.association_active && isJeniProduct && (
                              <SimpleButton
                                className="action-cancel-button"
                                title={t('device_context.delete_from_user_account')}
                                disabled={showSpinner}
                                onClick={() => setShowRemoveAssociationConfirmationModal(true)}
                              >
                                {t('device_context.delete_from_account')}
                              </SimpleButton>
                            )}
                            {!selectedSerial.association_active && (
                              <SimpleButton
                                className="action-cancel-button"
                                title={t('device_context.delete_from_user_account')}
                                disabled={showSpinner}
                                onClick={() => setShowRemoveProductConfirmationModal(true)}
                              >
                                {t('device_context.delete_from_account')}
                              </SimpleButton>
                            )}
                            {(isBravoProduct || isJeniProduct) && !selectedSerial.association_active && (
                              <SimpleButton
                                className="submit-button"
                                onClick={() => {
                                  if (isBravoProduct) {
                                    setShowBravoOnlineAccess(true)
                                  } else if (isJeniProduct) {
                                    setShowJeniOnlineAccess(true)
                                  }
                                }}
                              >
                                {t('products.activate_online_access_now')}
                              </SimpleButton>
                            )}
                          </div>
                        </div>
                      </div>

                      {!selectedSerial.association_active && isG4Device && (
                        <div className="activation-box-text">
                          <div className="icon-wrapper">
                            <InformationIcon />
                          </div>
                          <div className="activation-wrapper">
                            <div className="title">{t('products.activate_online_access')}</div>
                            <span>{isJeniProduct ? t('products.activation_message_jenievo') : t('products.activation_message')}</span>
                            <span
                              className="activation-steps"
                              onClick={() => setShowProductActivationStepsModal(true)}
                              tabIndex={0}
                              role="button"
                              onKeyDown={(e) => e.key === keyboardEvents.ENTER && setShowProductActivationStepsModal(true)}
                            >
                              {t('products.click_to_activate_online_access')}
                            </span>
                          </div>
                        </div>
                      )}

                      <div className="product-details-wrapper">
                        {hasUpdateAvailable && (
                          <div className="product-software-wrapper">
                            <div className="update-wrapper">
                              <div className="info-wrapper">
                                <div className="small-section-title">{t('device_context.update_available')}</div>
                                {isG4Device && (
                                  <div className="title-version">
                                    <span>{`${t('products.current_version')} `}</span>
                                    <span className="current-version">{replaceExtension(currentSoftwareVersion)}</span>
                                  </div>
                                )}
                                <div className="title-version">
                                  <span>{`${t('products.latest_version')} `}</span>
                                  <span className="latest-version">{replaceExtension(latestSoftwareVersion)}</span>
                                </div>
                              </div>
                              <div className="update-dot" />
                            </div>
                          </div>
                        )}

                        {isG4Device && !isJeniProduct && (
                          <div className="product-cycles-wrapper">
                            <div className="section-title">{t('products.last_cycles')}</div>
                            <div className="cycles-wrapper">
                              {lastCycles.map((cycle, index) => (
                                <div
                                  key={index}
                                  className={'cycle-item-wrapper ' + `${cycle.className}`}
                                  onClick={() => handleOpenCycleDetails(cycle)}
                                  tabIndex={0}
                                  role="button"
                                  onKeyDown={(e) => e.key === keyboardEvents.ENTER && handleOpenCycleDetails(cycle)}
                                >
                                  <div className="title">{cycle.title}</div>
                                  <div className="time">{buildUserFriendlyDate(cycle.start)}</div>
                                </div>
                              ))}
                              {!cyclesLoading && lastCycles.length === 0 && (
                                <div className="no-cycles-wrapper">
                                  <p className="disclaimer">{t('products.no_cycles_available')}</p>
                                </div>
                              )}
                            </div>
                            <div className="d-flex gap-8">
                              <SimpleButton className="action-button" onClick={() => navigateToProductPage()}>
                                {t('products.view_cycles_calendar')}
                              </SimpleButton>
                              {isBravoProduct && hasOnlineAccess && (
                                <SimpleButton className="action-button" onClick={() => syncBravoCycles()} disabled={showSpinner}>
                                  {t('device_context.sync_cycles')}
                                </SimpleButton>
                              )}
                            </div>
                          </div>
                        )}

                        {!isJeniProduct && (
                          <div className="product-firmware-wrapper">
                            <div className="section-title">{t('nav.firmware')}</div>
                            <div className="firmware-wrapper">
                              {displayedInstructionSoftware && (
                                <>
                                  <div className="instruction-box-text">
                                    <div className="icon-wrapper">
                                      <InformationIcon />
                                    </div>
                                    <div className="instruction-wrapper">
                                      <div className="title">{t('firmware_context.update_instructions')}</div>
                                      {renderProductSteps(selectedProduct.model, firmwareVideo, openVideoModal)}
                                    </div>
                                  </div>
                                  <div className="internal-section-title">{t('firmware_context.instructions_other_documents')}</div>
                                  <div className="firmware-documents-wrapper">
                                    {displayedInstructionSoftware?.map((document, index) => (
                                      <div className="firmware-documents d-flex" key={index}>
                                        <div className="name-wrapper d-flex flex-align-center">
                                          {getFileIcon(document.label)}
                                          <div className="file-name">{replaceExtension(document.label)}</div>
                                        </div>
                                        <SimpleButton className="action-button" onClick={() => downloadFirmwareFile(document)} disabled={showSpinner}>
                                          {t('download')}
                                        </SimpleButton>
                                      </div>
                                    ))}
                                  </div>
                                </>
                              )}
                              {!displayedInstructionSoftware &&
                                uiControlSoftwares &&
                                uiControlSoftwares.length > 0 &&
                                uiControlSoftwares[0].prefix === 'UC150' && (
                                  <>
                                    <div className="instruction-box-text">
                                      <div className="icon-wrapper">
                                        <InformationIcon />
                                      </div>
                                      <div className="instruction-wrapper">
                                        <div className="title">{t('firmware_context.update_instructions')}</div>
                                        {renderModelSteps('BioSonic UC150')}
                                      </div>
                                    </div>
                                  </>
                                )}

                              {!isHydrim112Model && renderFirmwareSection(uiSoftwares, 'lcd_board_software')}
                              {renderFirmwareSection(uiControlSoftwares, 'lcd_main_board_software')}
                              {!displayedInstructionSoftware && uiSoftwares.length === 0 && uiControlSoftwares.length === 0 && (
                                <div className="no-firmware-wrapper">
                                  <p className="disclaimer">{t('firmware_context.no_firmware_update_available')}</p>
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        <div className="product-documents-wrapper">
                          <div className="section-title">{t('products.documents_available')}</div>
                          <div className="documents-wrapper">
                            {documents.map((item, index) => (
                              <div
                                key={index}
                                className="document-item-wrapper"
                                onClick={() => handleDocumentDownload(item, gaCategories.productPage)}
                                tabIndex={0}
                                role="button"
                                onKeyDown={(event) => {
                                  if (event.key === keyboardEvents.ENTER) {
                                    handleDocumentDownload(item, gaCategories.productPage)
                                  }
                                }}
                              >
                                <div className="image-wrapper">
                                  <DownloadModernIcon />
                                </div>
                                <div className="image-wrapper rounded-image">
                                  {item.is_external_document ? <ExternalUrlIcon /> : getFileIcon(item.file_name)}
                                </div>
                                <div className="title-wrapper">
                                  <p className="title">{item?.document_title ? item?.document_title : item?.file_name}</p>
                                  <p className="section">{item?.section_name}</p>
                                </div>
                              </div>
                            ))}
                            {documents.length === 0 && (
                              <div className="no-documents-wrapper">
                                <p className="disclaimer">{t('document_context.no_documents_yet')}</p>
                              </div>
                            )}
                          </div>
                          <SimpleButton className="action-button" disabled={documents.length === 0} onClick={() => handleDocumentsModal(true)}>
                            {t('document_context.view_all_documents')}
                          </SimpleButton>
                        </div>

                        <div className="product-videos-wrapper">
                          <div className="section-title">{t('nav.videos')}</div>
                          <div className="videos-wrapper">
                            {videos.map((video, index) => (
                              <div
                                key={index}
                                className="video-item-wrapper"
                                onClick={() => openVideoModal(video)}
                                tabIndex={0}
                                role="button"
                                onKeyDown={(e) => e.key === keyboardEvents.ENTER && openVideoModal(video)}
                              >
                                <div className="thumbnail-wrapper">
                                  <div className="thumbnail-icon">
                                    <VideoPlayIcon />
                                  </div>
                                  <img src={video.thumbnail_url} alt="video" />
                                </div>
                                <p className="title">{video.title}</p>
                              </div>
                            ))}
                            {videos.length === 0 && (
                              <div className="no-videos-wrapper">
                                <p className="disclaimer">{t('video_context.no_videos_yet')}</p>
                              </div>
                            )}
                          </div>
                          <SimpleButton className="action-button" disabled={videos.length === 0} onClick={() => handleVideosModal(true)}>
                            {t('video_context.view_all_videos')}
                          </SimpleButton>
                        </div>
                      </div>
                    </>
                  )}
                  {!selectedSerial && <EmptyPageResults title={t('no_product_selected')} subtitle={t('troubleshoot.select-product')} />}
                </div>
              ) : selectedProduct && isICTrackProduct && showFeatureDev ? (
                <div className="serials-wrapper">
                  <p className="serial-select-title">{`${t('products.linked_devices')} (${selectedProduct.products?.length})`}</p>
                  <div className="linked-products-wrapper">
                    {selectedProduct.products
                      ?.slice(0, showLimitedLikedDevice ? linkedDevicesLimit : selectedProduct.products.length)
                      ?.map((product, index) => (
                        <div
                          key={index}
                          className={'linked-product' + (product.isSciCanProduct ? ' with-navigation' : '')}
                          onClick={() => product.isSciCanProduct && navigateToProduct(product.serial_number)}
                          tabIndex={0}
                          role="button"
                          onKeyDown={(e) => e.key === keyboardEvents.ENTER && product.isSciCanProduct && navigateToProduct(product.serial_number)}
                        >
                          <img src={getImageByModel(mapSerialToModel(product.serial_number))} className="product-image" alt="product" />
                          <div className="product-nickname">{product.unit_nickname}</div>
                          <div className="product-serial">{product.serial_number && `${t('sn')} ${product.serial_number}`}</div>
                        </div>
                      ))}
                  </div>
                  {selectedProduct.products?.length > linkedDevicesLimit && showLimitedLikedDevice && (
                    <div
                      onClick={() => setShowLimitedLikedDevice(false)}
                      className="content-limiter"
                      tabIndex={0}
                      role="button"
                      onKeyDown={(e) => e.key === keyboardEvents.ENTER && setShowLimitedLikedDevice(false)}
                    >
                      {`+${selectedProduct.products.length - linkedDevicesLimit} ${t('more')}`}
                    </div>
                  )}
                  {!showLimitedLikedDevice && (
                    <div
                      onClick={() => setShowLimitedLikedDevice(true)}
                      className="content-limiter"
                      tabIndex={0}
                      role="button"
                      onKeyDown={(e) => e.key === keyboardEvents.ENTER && setShowLimitedLikedDevice(true)}
                    >
                      {t('view_less')}
                    </div>
                  )}

                  <div className="product-details-wrapper">
                    <div className="product-cycles-wrapper">
                      <div className="section-title with-extra-information">{t('nav.instrument_tracking')}</div>
                      <div className="extra-information">{t('products.last_days')}</div>
                      <div className="cycles-wrapper ic-track-cycles-wrapper">
                        {lastCycles.map((cycle, index) => (
                          <div
                            key={index}
                            className={'cycle-item-wrapper ' + `${cycle.className}`}
                            onClick={() => handleOpenCycleDetails(cycle)}
                            tabIndex={0}
                            role="button"
                            onKeyDown={(e) => e.key === keyboardEvents.ENTER && handleOpenCycleDetails(cycle)}
                          >
                            <div className="icon-title-wrapper">
                              <div className="icon">
                                {cycle.type === 'washer' ? <WasherSmallIcon /> : <SterilizerSmallIcon />}
                                <div className="title">{cycle.serial_number ? `${t('sn')}: ${cycle.serial_number}` : cycle.nickName}</div>
                              </div>
                              <div className="cycle-num">{cycle.title}</div>
                            </div>
                          </div>
                        ))}
                        {!cyclesLoading && lastCycles.length === 0 && (
                          <div className="no-cycles-wrapper">
                            <p className="disclaimer">{t('products.no_cycles_available')}</p>
                          </div>
                        )}
                      </div>
                      <div className="cycles-navigation-buttons-wrapper">
                        <SimpleButton className="action-button" onClick={() => navigateToInstrumentTracking()}>
                          {t('products.view_instrument_tracking_calendar')}
                        </SimpleButton>
                        <SimpleButton className="action-button" onClick={() => navigateToInstrumentTrackingReports()}>
                          {t('products.view_instrument_reprocessing_report')}
                        </SimpleButton>
                      </div>
                    </div>

                    <div className="product-documents-wrapper">
                      <div className="section-title">{t('nav.documents')}</div>
                      <div className="documents-wrapper">
                        {documents.map((item, index) => (
                          <div
                            key={index}
                            className="document-item-wrapper"
                            onClick={() => handleDocumentDownload(item, gaCategories.productPage)}
                            tabIndex={0}
                            role="button"
                            onKeyDown={(e) => e.key === keyboardEvents.ENTER && handleDocumentDownload(item, gaCategories.productPage)}
                          >
                            <div className="image-wrapper">
                              <DownloadModernIcon />
                            </div>
                            <div className="image-wrapper rounded-image">{getFileIcon(item.file_name)}</div>
                            <div className="title-wrapper">
                              <p className="title">{item?.document_title ? item?.document_title : item?.file_name}</p>
                              <p className="section">{item?.section_name}</p>
                            </div>
                          </div>
                        ))}
                        {documents.length === 0 && (
                          <div className="no-documents-wrapper">
                            <p className="disclaimer">{t('document_context.no_documents_yet')}</p>
                          </div>
                        )}
                      </div>
                      <SimpleButton className="action-button" disabled={documents.length === 0} onClick={() => handleDocumentsModal(true)}>
                        {t('document_context.view_all_documents')}
                      </SimpleButton>
                    </div>

                    <div className="product-videos-wrapper">
                      <div className="section-title">{t('nav.videos')}</div>
                      <div className="videos-wrapper">
                        {videos.map((video, index) => (
                          <div
                            key={index}
                            className="video-item-wrapper"
                            onClick={() => openVideoModal(video)}
                            tabIndex={0}
                            role="button"
                            onKeyDown={(e) => e.key === keyboardEvents.ENTER && openVideoModal(video)}
                          >
                            <div className="thumbnail-wrapper">
                              <div className="thumbnail-icon">
                                <VideoPlayIcon />
                              </div>
                              <img src={video.thumbnail_url} alt="video" />
                            </div>
                            <p className="title">{video.title}</p>
                          </div>
                        ))}
                        {videos.length === 0 && (
                          <div className="no-videos-wrapper">
                            <p className="disclaimer">{t('video_context.no_videos_yet')}</p>
                          </div>
                        )}
                      </div>
                      <SimpleButton className="action-button" disabled={videos.length === 0} onClick={() => handleVideosModal(true)}>
                        {t('video_context.view_all_videos')}
                      </SimpleButton>
                    </div>

                    {supportsColteneStore && (
                      <div className="product-related-products-wrapper">
                        <div className="section-title">{t('products.related_products')}</div>
                        <div className="related-products-wrapper">
                          {relatedProducts.length === 0 && (
                            <div className="no-related-products-wrapper">
                              <p className="disclaimer">{t('products.no_related_products_available')}</p>
                            </div>
                          )}
                        </div>
                        <SimpleButton className="action-button" onClick={() => navigateToColteneStore()}>
                          {t('products.go_to_store')}
                        </SimpleButton>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div className="no-product-selected">
                  <EmptyPageResults text={t('products.no_product_selected')} />
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {isMobile && selectedProduct && !showTilesView && (
        <ProductDetailsModal
          canAccessInstrumentTracking={canAccessInstrumentTracking}
          selectedProduct={selectedProduct}
          serials={serials}
          selectedSerial={selectedSerial}
          onSelectSerial={(serialNr) => selectSerial(serialNr)}
          productSerialNickname={productSerialNickname}
          hasOnlineAccess={hasOnlineAccess}
          hasPrivacyPolicyChecked={hasPrivacyPolicyChecked}
          hasUpdateAvailable={hasUpdateAvailable}
          currentSoftwareVersion={currentSoftwareVersion}
          latestSoftwareVersion={latestSoftwareVersion}
          productIsAperture={productIsAperture}
          isBravoProduct={isBravoProduct}
          isJeniProduct={isJeniProduct}
          onShowNotifications={() => setShowNotifications(true)}
          onShowBravoOnlineAccess={() => setShowBravoOnlineAccess(true)}
          onShowJeniOnlineAccess={() => setShowJeniOnlineAccess(true)}
          onDeleteProduct={() => setShowRemoveProductConfirmationModal(true)}
          onDisassociateProduct={() => setShowRemoveAssociationConfirmationModal(true)}
          lastCycles={lastCycles}
          onShowCycleDetails={(cycle) => handleOpenCycleDetails(cycle)}
          handleOpenProductActivationStepsModal={() => setShowProductActivationStepsModal(true)}
          handleOpenNicknameSetupModal={() => setShowNicknameSetupModal(true)}
          handleOpenDeleteNicknameModal={() => setShowDeleteNicknameModal(true)}
          handleNavigateToProductPage={(serialNumber) => navigateToProductPage(serialNumber)}
          documents={documents}
          handleOpenDocumentsModal={() => handleDocumentsModal(true)}
          videos={videos}
          handleOpenVideosModal={() => handleVideosModal(true)}
          onSelectVideo={(video) => openVideoModal(video)}
          displayedInstructionSoftware={displayedInstructionSoftware}
          uiSoftwares={uiSoftwares}
          uiControlSoftwares={uiControlSoftwares}
          firmwareVideo={firmwareVideo}
          onDownloadFirmware={(file) => downloadFirmwareFile(file)}
          isICTrackProduct={isICTrackProduct}
          showSpinner={showSpinner}
          cyclesLoading={cyclesLoading}
          closeModal={handleBackToTiles}
          linkedDevicesLimit={linkedDevicesLimit}
          relatedProducts={relatedProducts}
          showLimitedLikedDevice={showLimitedLikedDevice}
          onShowLimitedLinkedDevices={(shouldShow) => setShowLimitedLikedDevice(shouldShow)}
          handleNavigateToInstrumentTracking={() => navigateToInstrumentTracking()}
          handleNavigateToInstrumentTrackingReports={() => navigateToInstrumentTrackingReports()}
          handleNavigateToStore={() => navigateToColteneStore()}
          handleNavigateToProduct={(serialNumber) => navigateToProduct(serialNumber)}
          mapSerialToModel={mapSerialToModel}
          isG4Device={isG4Device}
          syncBravoCycles={() => syncBravoCycles()}
          showFeatureDev={showFeatureDev}
        />
      )}
      {showNotifications && isBravoProduct && (
        <Modal className="notification-settings" toggle={showNotifications} onToggle={() => setShowNotifications(false)}>
          <NotificaitonSettings serialNumber={selectedSerial.serial_number} model={selectedProduct?.model} />
        </Modal>
      )}
      {showNotifications && !isBravoProduct && (
        <NotificationSettings
          serialNumber={selectedSerial.serial_number}
          model={selectedProduct?.model}
          modelImage={getImageByModel(selectedProduct?.model)}
          closeModal={() => setShowNotifications(false)}
        />
      )}
      {showInstrumentTrackingDetails && (
        <CycleModal
          selectedEvent={cycleDetailsDeviceData}
          selectedModel={mapSerialToModel(cycleDetailsDeviceData?.deviceSerialNumber)}
          isLoading={showSpinner}
          handleOpenCycleGraph={() => {
            setShowInstrumentTrackingDetails(false)
            setShowCycleDetails(true)
          }}
          closeModal={() => setShowInstrumentTrackingDetails(false)}
        />
      )}
      {showCycleDetails && (
        <CycleDetailsModal
          deviceData={cycleDetailsDeviceData}
          cycleDetails={cycleDetails}
          selectedModel={mapSerialToModel(cycleDetailsDeviceData?.deviceSerialNumber)}
          closeModal={() => {
            setShowCycleDetails(false)
            setCycleDetails({})
            setCycleDetailsDeviceData({})
          }}
          handleExternalNavigationToTroubleshooting={() => cycleNavigateToTroubleshooting()}
        />
      )}
      {selectedVideo && (
        <VideoModal
          title={selectedVideo.title}
          videoId={selectedVideo.video_id}
          onCloseVideo={closeVideoModal}
          gaAction={gaActions.videoClick}
          gaCategory={gaCategories.productPage}
        />
      )}
      {showRegisterProduct && <RegisterProductModern closeModal={() => handleRegisterProductModal(false)} />}
      {showFiltersModal && (
        <FiltersModal
          filters={[
            {
              name: t('model'),
              type: FilterType.multiSelect,
              dataset: availableModels,
              input: modelFilter,
              output: (filterModels) => {
                setModelFilter(filterModels)
              },
            },
          ]}
          shouldFilter={(shouldApply) => setShouldApplyFilters(shouldApply)}
          resetFilters={() => handleResetFilters()}
          closeFilters={() => setShowFiltersModal(false)}
        />
      )}
      {showVideosModal && (
        <Modal toggle onToggle={() => handleVideosModal(false)} className="videos">
          <Videos model={selectedProduct?.model} hideFilters hideBreadcrumb hideDisclaimer={true} />
        </Modal>
      )}
      {showDocumentsModal && (
        <Modal toggle onToggle={() => handleDocumentsModal(false)} className="documents">
          <Documents className={'products-document-wrapper'} model={selectedProduct?.model} hideBreadcrumb hideFiltering />
        </Modal>
      )}
      {showProductActivationStepsModal && (
        <ProductActivationStepsModal
          closeModal={() => setShowProductActivationStepsModal(false)}
          isG4Plus={selectedSerial?.is_g4_plus}
          isBravoDevice={isBravoProduct}
          model={selectedProduct?.model}
        />
      )}
      {showNicknameSetupModal && (
        <NicknameSetupModal
          closeModal={() => setShowNicknameSetupModal(false)}
          nickname={productSerialNickname}
          productIsAperture={productIsAperture}
          showSpinner={showSpinner}
          handleChangeNickname={(newNickname) => handleChangeNickname(newNickname)}
        />
      )}
      {showDeleteNicknameModal && (
        <ConfirmationModal
          onToggle={() => setShowDeleteNicknameModal(false)}
          onCancel={() => setShowDeleteNicknameModal(false)}
          onAccept={() => {
            handleChangeNickname('')
            setShowDeleteNicknameModal(false)
          }}
          message={t('products.delete_nickname_confirmation')}
          acceptButtonText={t('delete')}
          isWarning
          requiredPermission={userProductsWritePermission}
        />
      )}
      {showBravoOnlineAccess && activationModels !== null && (
        <Modal toggle onToggle={() => setShowBravoOnlineAccess(false)} className="online-activation token-activation">
          <OnlineAccess
            toggleShowOnlineAccess={() => setShowBravoOnlineAccess(false)}
            isBravoG4OnlineAccess
            setIsSuccessOnlineActivation={() => onSuccessfulOnlineActivation()}
            serialNumber={selectedSerial?.serial_number}
            model={selectedProduct?.model}
            activationModels={activationModels}
          />
        </Modal>
      )}
      {showJeniOnlineAccess && activationModels !== null && (
        <Modal toggle onToggle={() => setShowJeniOnlineAccess(false)} className="online-activation token-activation">
          <OnlineAccess
            toggleShowOnlineAccess={() => setShowJeniOnlineAccess(false)}
            isJeniOnlineAccess
            setIsSuccessOnlineActivation={() => onSuccessfulOnlineActivation()}
            serialNumber={selectedSerial?.serial_number}
            model={selectedProduct?.model}
            activationModels={activationModels}
          />
        </Modal>
      )}
      {showRemoveProductConfirmationModal && (
        <ConfirmationModal
          onToggle={() => setShowRemoveProductConfirmationModal(false)}
          message={t('device_context.unit.remove_device_confirmation')}
          onCancel={() => setShowRemoveProductConfirmationModal(false)}
          onAccept={() => {
            handleDeleteProduct()
            setShowRemoveProductConfirmationModal(false)
          }}
          isWarning
        />
      )}
      {showRemoveAssociationConfirmationModal && (
        <ConfirmationModal
          onToggle={() => setShowRemoveAssociationConfirmationModal(false)}
          message={t('device_context.disassociate_jenievo')}
          onCancel={() => setShowRemoveAssociationConfirmationModal(false)}
          onAccept={() => {
            handleDeleteProduct()
            setShowRemoveAssociationConfirmationModal(false)
          }}
          isWarning
        />
      )}
      {(props.userProductsAreLoading || showSpinner) && (
        <div className="spinner-wrapper">
          <LoadingSpinner />
        </div>
      )}
    </div>
  )
}

function mapStateToProps({ userProducts, authedUser, userPermissions, apertures, firmware, userCompany, backNavigationState }) {
  return {
    userProducts: userProducts?.products || {},
    userProductsAreLoading: userProducts?.loading,
    authedUser,
    apertures: apertures?.apertures || [],
    devicesUpdateAvailableStatus: firmware?.devicesUpdateAvailableStatus || {},
    userPermissions,
    backNavigationState,
    userBranches: userCompany?.userBranches || [],
  }
}

function dispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        setBackNavigationState,
      },
      dispatch,
    ),
  }
}

export default connect(mapStateToProps, dispatchToProps)(MyProducts)

